package com.milta.core.localization.translations.sq

import com.milta.core.localization.SpreadsheetImportStrings

internal val SpreadsheetImport = SpreadsheetImportStrings(
    importFileTitle = "Importo një skedar",
    analysingTitle = "Duke analizuar skedarin…",
    analysingSubtitle = "Ne identifikojmë kolonat dhe zbulojmë dërgesat në tabelë.",
    fileSentSuffix = "dërguar tani",
    structuredFormatBannerTitle = "Formati u njoh.",
    structuredFormatBannerMessage = "Kolonat u përshtatën automatikisht, nuk nevojitet asnjë korrigjim.",
    columnsInterpretedBannerTitle = "Kolonat u interpretuan automatikisht.",
    columnsInterpretedBannerMessage = "Kontrolloni dërgesat e shënuara para se t'i shtoni.",
    completePillLabel = "Gjithçka është e plotë",
    invalidFileTitle = "Skedari nuk mbështetet.",
    invalidFileMessage = "Importoni një skedar Excel (.xlsx) ose CSV (.csv) të vlefshëm.",
    chooseAnotherFileButton = "Zgjidh një skedar tjetër",
    extractionFailedTitle = "Ky skedar nuk mund të lexohet.",
    extractionFailedMessage = "Tabela duket bosh ose struktura e saj nuk u njoh — kontrolloni përmbajtjen ose fusni dërgesat manualisht.",
    retryWithNewFileButton = "Provo përsëri me një skedar tjetër",
    serviceUnavailableTitle = "Shërbimi i analizës është përkohësisht i padisponueshëm.",
    serviceUnavailableMessage = "Provoni përsëri pas pak, ose plotësoni këtë dërgesë manualisht ndërkohë.",
)
